import { defineStore } from 'pinia';
import { ref } from 'vue';
import expensesAPI from '@/api/expenses';
import { useAlertStore } from '@/store/alertStore';

export const useExpensesStore = defineStore('expenses', () => {
  const expenses = ref<any[]>([]);
  const expenses_search = ref<any[]>([]);
  const alertStore = useAlertStore();

  const fetchExpenses = async (params: any): Promise<{ data: any[]; total: number }> => {
    const response = await expensesAPI.getExpenses(params);
    const data = response.data.data;
    const total = response.data.meta?.total ?? data.length;
    expenses.value = data;
    return { data, total };
  };

  const fetchExpenseById = async (id: number) => {
    const response = await expensesAPI.getExpenseById(id);
    return response.data.data;
  };

  const createExpense = async (payload: any) => {
    const response = await expensesAPI.createExpense(payload);
    if (!response.data.success) throw response.data;
    expenses.value.push(response.data.data);
    alertStore.showAlert('Gasto creado con éxito', 'success');
    return response.data;
  };

  const updateExpense = async (id: number, payload: any) => {
    const response = await expensesAPI.updateExpense(id, payload);
    if (!response.data.success) throw response.data;
    const updated = response.data.data;
    const idx = expenses.value.findIndex((e: any) => e.id === id);
    if (idx !== -1) expenses.value[idx] = updated;
    alertStore.showAlert('Gasto actualizado con éxito', 'success');
    return response.data;
  };

  const deleteExpense = async (id: number) => {
    await expensesAPI.deleteExpense(id);
    expenses.value = expenses.value.filter((e: any) => e.id !== id);
    alertStore.showAlert('Gasto eliminado con éxito', 'success');
  };

  const searchExpenses = async (params: any) => {
    const response = await expensesAPI.getExpenses(params);
    expenses_search.value = response.data.data;
    return expenses_search.value;
  };

  return {
    expenses,
    expenses_search,
    fetchExpenses,
    fetchExpenseById,
    createExpense,
    updateExpense,
    deleteExpense,
    searchExpenses,
  };
});
